import { cleanUrl } from 'mini-common-utils/lib/utils/cleanUrl';
import { historyBackWithModuleLevelFallbackUrl } from 'dom-utils/lib/utils/customHistoryBack';
import { useHistory, useLocation } from 'react-router-dom';

export interface ChangeRouteParams {
    pushRoute: (newPath: string, appendToCurrentPath?: boolean) => void;
    replaceRoute: (newPath: string, appendToCurrentPath?: boolean) => void;
    goBack: (steps?: number) => void;
}

/**
 * Hook which returns the utilities for changing the route
 */
export const useChangeRoute = () => {
    const history = useHistory();
    const location = useLocation();

    const currentPath = location.pathname;

    const getNewLocation = (newPath: string, appendToCurrentPath?: boolean) => ({
        ...location,
        pathname: cleanUrl(appendToCurrentPath ? `${currentPath}/${newPath}` : newPath),
    });

    const pushRoute = (newPath: string, appendToCurrentPath?: boolean) => {
        history.push(getNewLocation(newPath, appendToCurrentPath));
    };
    const replaceRoute = (newPath: string, appendToCurrentPath?: boolean) => {
        history.replace(getNewLocation(newPath, appendToCurrentPath));
    };

    const goBack = historyBackWithModuleLevelFallbackUrl;

    return { goBack, pushRoute, replaceRoute };
};
